import { render } from "./SideRightNavEditor.vue?vue&type=template&id=366e9d1e"
import script from "./SideRightNavEditor.vue?vue&type=script&lang=js"
export * from "./SideRightNavEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__